import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'sonner'
import Landing from './pages/Landing'
import Dashboard from './pages/Dashboard'
import History from './pages/History'
import Requisites from './pages/Requisites'
import Offer from './pages/Offer'
import Privacy from './pages/Privacy'
import { WbTokenProvider } from './hooks/useWbToken'

function App() {
  return (
    <BrowserRouter>
      <WbTokenProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/requisites" element={<Requisites />} />
          <Route path="/offer" element={<Offer />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/history" element={<History />} />

          {/* Редирект на главную для неизвестных маршрутов */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </WbTokenProvider>
    </BrowserRouter>
  )
}

export default App
